import {publicTrackFixedLayerIds} from './fixedLayerIds';
import {blurOpacity} from './constants';

export default function getPublicTracksMapboxStyle({
    showPublicTracks,
    highlight,
    interaction
}: {showPublicTracks: undefined | boolean; highlight: MapHighlight; interaction: MapInteraction}
): mapboxgl.Style | undefined {
    if (highlight) return undefined;
    if (!showPublicTracks) return undefined;

    return {
        version: 8,
        metadata: {
            uniqueTilecacheKey: 'publicTracks'
        },
        sources: {
            source: {
                type: 'vector',
                tiles: [`${window.location.origin}/api/public/tiles/{z}/{x}/{y}.mvt`],
                minzoom: 8,
                maxzoom: 15,
            }
        },
        layers: [{
            id: publicTrackFixedLayerIds.line,
            type: 'line',
            source: 'source',
            'source-layer': 'tracks',
            paint: {
                'line-color': ['coalesce' as mapboxgl.ExpressionName, ['get', 'color'], '#00FF00'],
                'line-width': 3,
                'line-opacity': interaction.type === 'editingRoute' ? blurOpacity : 0.8,
            },
        }]
    };
}
